import { render, staticRenderFns } from "./BarChart.vue?vue&type=template&id=63a744df&scoped=true&"
import script from "./BarChart.vue?vue&type=script&lang=js&"
export * from "./BarChart.vue?vue&type=script&lang=js&"
import style0 from "./BarChart.vue?vue&type=style&index=0&id=63a744df&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a744df",
  null
  
)

export default component.exports